import React, { useMemo } from "react";
import StatCardGroup from "../Common/StatCardGroup";
import { Col, Row } from "react-bootstrap";
import VolumeRevenueTrend from "./VolumeRevenueTrend";
import TotalRevenue from "./TotalRevenue";
import DonutDistribution from "../Common/DonutDistribution";
import AppVsPOS from "./AppVsPOS";
import TierMovementCard from "./TierMovement";
import RecentTransactions from "./RecentTransactions";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Financial = () => {
  const { t, i18n } = useTranslation();
  const statsData = useSelector((state) => state.Dashboard?.data?.stats?.stats);
  const donutChartData = useSelector(
    (state) => state.Dashboard?.data?.donutChart,
  );
  const chartsData = useSelector(
    (state) => state.Dashboard?.data?.charts,
  );
  const distributionBYPlanData = donutChartData?.distributionsByPlan;
  const tierMovement = donutChartData?.tierMovement;
  const revenueBySource = donutChartData?.revenueBySource;
  const revenueChartData = chartsData?.revenueChart;
  const totalRevenueByPlanTypes = chartsData?.revenueByPlanTypes;

  const DASHBOARD_STATS = [
    {
      id: "totalRevenue2",
      title: "Total Revenue",
      value: statsData?.totalRevenue,
      icon: "totalRevenue2",
      type: "price",
    },
    {
      id: "avgRevenuePerCar",
      title: "Avg.Revenue Per Car",
      value: statsData?.avgRevenuePerCar,
      icon: "avgRevenuePerCar",
      type: "price",
    },
    {
      id: "newTicket",
      title: "Avg.Ticket Value",
      value: `${statsData?.avgTicketValue} %`,
      icon: "newTicket",
    },
    {
      id: "appAdoptionRate",
      title: "Avg. Revenue Per User",
      value: statsData?.avgRevenuePerUser,
      icon: "appAdoptionRate",
      type: "price",
    },

    {
      id: "newMembership",
      title: "Membership Revenue",
      value: statsData?.membershipRevenue,
      icon: "newMembership",
      type: "price",
    },
    {
      id: "singleWashRevenue",
      title: "Single Wash Revenue",
      value: statsData?.singleWashRevenue,
      icon: "singleWashRevenue",
      type: "price",
    },
    {
      id: "interiorRevenue",
      title: "Interior Revenue",
      value: statsData?.interiorRevenue,
      icon: "interiorRevenue",
      type: "price",
    },
    {
      id: "MPR",
      title: "MPR ",
      value: statsData?.monthlyPaymentRevenue,
      icon: "MPR",
      type: "price",
    },
  ];
  const PLAN_COLOR_MAP = {
    "Unlimited Shine": "#F3AA41",
    "Unlimited Protect": "#523677",
    "Unlimited The Works": "#DE235C",
  };
  const DEFAULT_COLOR = "#CBD5E1";

  const PLAN_REVENUE_DISTRIBUTION = useMemo(() => {
    if (!Array.isArray(distributionBYPlanData)) return [];

    return distributionBYPlanData.map((item) => ({
      name: i18n.language === "ar" ? item.planTitle?.ar : item.planTitle?.en,
      value: Number(item.percentage),
      color: PLAN_COLOR_MAP[item.planTitle?.en] || DEFAULT_COLOR,
    }));
  }, [distributionBYPlanData, i18n.language]);

  return (
    <div className="financial_dashboard">
      <StatCardGroup items={DASHBOARD_STATS} />
      <Row>
        <Col xxl={8} xl={7}>
          <VolumeRevenueTrend revenueData={revenueChartData} />
        </Col>
        <Col xxl={4} xl={5}>
          <TotalRevenue revenueData={totalRevenueByPlanTypes} />
        </Col>
      </Row>
      <Row>
        <DonutDistribution
          title="Plan wise Revenue Distribution"
          data={PLAN_REVENUE_DISTRIBUTION}
        />
        <Col lg={4}>
          <AppVsPOS  revenueBySource={revenueBySource}/>
        </Col>
        <Col xxl={4}>
          <TierMovementCard upgrades={tierMovement?.upgrades} downgrades={tierMovement?.upgrades} dataUnit={tierMovement?.dataUnit} max={100} />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <RecentTransactions />
        </Col>
      </Row>
    </div>
  );
};

export default Financial;
